import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface DigitalConsultationStore {
  patientName: string
  setPatientName: (name: string) => void
}

export const useDigitalConsultationStore = create<DigitalConsultationStore>()(
  devtools((set) => ({
    patientName: '',
    setPatientName(name) {
      set({ patientName: name }, false, 'setPatientNameDigitalConsultation')
    }
  }))
)
